"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  deleted: 'Удален',
  closed: 'Профиль пользователя находится в закрытом режиме. Просмотр информации недоступен'
};